import * as Sentry from '@sentry/vue'

function safeStringify(obj) {
  const seen = new WeakSet()
  try {
    return JSON.stringify(obj, (key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) return '[Circular]'
        seen.add(value)
      }
      return value
    })
  } catch {
    return '[Stringify Error]'
  }
}

/**
 * Axios 请求上报 Sentry 插件
 *
 * 必须在所有其他插件之前注册（最先注册 = 最后执行），
 * 确保捕获到 traceId 等其他插件注入的完整数据
 */
export default function sentryPlugin(axiosInstance) {
  axiosInstance.interceptors.request.use((config) => {
    Sentry.addBreadcrumb({
      category: 'http',
      type: 'http',
      message: `${(config.method || 'GET').toUpperCase()} ${config.url}`,
      data: {
        url: config.url,
        method: config.method,
        requestBody: config.data ? safeStringify(config.data) : '',
        tid: config.headers?.tid,
      },
      level: 'info',
    })
    return config
  })
}
